import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import giLogo from "../assets/logos/GI-logo.svg";
import klgiLogo from "../assets/logos/KLGI.png";
import igcgLogo from "../assets/logos/igcgLogo.png";
import bashkiaTiraneLogo from "../assets/logos/bashkiatirane.svg";

const partnerList = [
  {
    logo: bashkiaTiraneLogo,
    alt: "Partner 3",
  },
  {
    logo: giLogo,
    alt: "Partner 1",
    isGiLogo: true,
  },
  {
    logo: klgiLogo,
    alt: "Partner 2",
  },
  {
    logo: igcgLogo,
    alt: "Partner 3",
    isIgcgLogo: true,
  },
];

gsap.registerPlugin(ScrollTrigger);

const Partners = () => {
  const partnerRefs = useRef([]);

  useEffect(() => {
    partnerRefs.current.forEach((partnerRef, index) => {
      gsap.fromTo(
        partnerRef,
        {
          opacity: 0,
          scale: 0.5, // Start from smaller size
        },
        {
          opacity: 1,
          scale: 1, // End with normal size
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: partnerRef,
            start: "top 85%", // Trigger when 85% of the element is visible
            toggleActions: "play none none none", // Play the animation once
          },
        }
      );
    });
  }, []);

  return (
    <section
      id="partners"
      className="py-20 xs:py-[3rem] xxs:py-[3rem] px-6 md:px-12 bg-[#DAF4F1] text-brandBlue font-outfit text-center"
      style={{ outline: "4px solid #daf4f1" }}
    >
      <div className="max-w-4xl mx-auto">
        <h3 className="text-3xl md:text-4xl xs:text-2xl xxs:text-2xl font-bold mb-4">
          Our Partners
        </h3>

        <p className="mb-8 text-lg xs:text-base xxs:text-base text-[#4C7C7D] leading-relaxed">
          We proudly collaborate with esteemed partners who support our vision
          of inclusive international governance
        </p>

        <div className="mt-12 grid gap-8 sm:grid-cols-2 place-items-center">
          {partnerList.map((partner, index) => (
            <div
              key={index}
              className="group flex flex-col items-center"
              ref={(el) => (partnerRefs.current[index] = el)} // Assigning ref to each partner logo
            >
              {partner.isGiLogo ? (
                <a
                  href="https://www.linkedin.com/company/international-governance-institute"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={partner.logo}
                    alt={partner.alt}
                    className={`w-[10rem] h-[5rem] object-contain  ${
                      partner.isGiLogo ? "scale-[4.5]" : ""
                    }`}
                  />
                </a>
              ) : (
                <img
                  src={partner.logo}
                  alt={partner.alt}
                  className={`w-[10rem] h-[5rem] object-contain  ${
                    partner.isGiLogo ? "scale-[4.5]" : ""
                  }`}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
